<template>
  <!-- 产品案例导航 -->
  <div class="case_menu_box page_con_center">
    <div class="big_text">产品案例</div>
    <div class="list_boxes">
      <div class="first_nav">
        <div
          class="nav_item"
          v-for="v in parentList"
          :key="v.value"
          :class="nowFirst == v.value ? 'this' : ''"
          @mouseover="onHover(v)"
          @click="toCaseListPage(v)"
        >
          <div class="text">{{ v.label }}</div>
          <div class="row"></div>
        </div>
      </div>
      <div class="right_nav_list">
        <div
          class="case_item"
          v-for="v in rightNav"
          :key="v.id"
          @click="toCaseDetailPage(v)"
        >
          <div class="cover_img">
            <img
              :src="require(`@/assets/image/case/${v.urlId}.png`)"
              class="cover"
            />
          </div>
          <div class="text_box">
            <div class="label">{{ v.productName }}</div>
            <div class="text text_ellipsis_2">{{ v.msg }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { caseDate } from "@/assets/js/caseData.js";
export default {
  data() {
    return {
      caseDateList: caseDate(),
      nowFirst: "02",
    };
  },
  computed: {
    parentList() {
      let _arr = this.caseDateList
        .map((v) => {
          return {
            label: v.type,
            value: v.parentId,
          };
        })
        .filter((currentValue, currentIndex, selfArr) => {
          return (
            selfArr.findIndex((x) => x.value === currentValue.value) ===
            currentIndex
          );
        });
      return _arr;
    },
    rightNav() {
      return this.caseDateList.filter((v) => v.parentId == this.nowFirst);
    },
  },
  created() {},
  mounted() {},
  methods: {
    onHover(row) {
      this.nowFirst = row.value;
    },
    // 案例列表页面
    toCaseListPage(row) {
      this.$emit("clickHandler", true);
      this.$router
        .push({
          path: `/productCase/${row.value}`,
        })
        .catch((err) => err);
    },
    // 案例详情页面
    toCaseDetailPage(row) {
      this.$emit("clickHandler", true);
      this.$router
        .push({
          path: `/productCase/detail/${this.nowFirst}/${row.id}`,
        })
        .catch((err) => err);
    },
  },
};
</script>
<style scoped lang="scss">
.case_menu_box {
  height: 100%;
  padding-bottom: 3px;
  & > div {
    float: left;
    width: 100%;
  }
  .big_text {
    height: 101px;
    line-height: 101px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .list_boxes {
    float: left;
    width: 100%;
    height: calc(100% - 101px);
    & *::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 6px;
    }
    & *::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 45px;
      background: #c1c1c1;
    }
    & *::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      background: #eee;
    }
    .first_nav {
      float: left;
      width: 340px;
      height: 100%;
      overflow-y: auto;
      margin-right: 10px;
      padding-right: 23px;
      .nav_item {
        float: left;
        width: 100%;
        height: 48px;
        @include flexBoxCenter(center, space-between);
        color: #777;
        font-size: 18px;
        padding: 0 14px 0 11px;
        cursor: pointer;
        transition: all 0.3s;
        &.this {
          background: #efefef;
          color: #333;
          .row {
            opacity: 1;
          }
        }
        .text {
          float: left;
        }
        .row {
          float: left;
          width: 20px;
          height: 20px;
          @include backgroundUrl("icon_right_row.png");
          opacity: 0;
        }
      }
    }
    .right_nav_list {
      border-left: 1px solid #edeff2;
      float: left;
      width: calc(100% - 350px);
      height: 100%;
      overflow-y: auto;
      padding: 0 16px;
    }
  }
}
</style>
